export const TABLE_PUBLIC_ORDERS = 'OrderList';
export const TABLE_PENDING_PUBLIC_ORDERS = 'PendingOrderList';
export const TABLE_PENDING_PROVIDER_PUBLIC_ORDERS = 'PendingProviderOrderList';

export const TABLE_MARKETPLACE_ORDERS = 'MarketplaceOrdersList';
export const MARKETPLACE_ORDERS_LIST_FILTER_FORM_ID =
  'MarketplaceOrdersListFilter';
